// // redux/store.js
// import { configureStore } from "@reduxjs/toolkit";
// import authReducer from "./reducers/authReducer.js";
// import jobReducer from "./reducers/jobReducer";
// import todayAttendanceReducer from "./reducers/TodayReducer"
// import {assignjobReducer,assignLocationReducer,jobAssignmentReducer} from "./reducers/AssignReducer.js";
// import { assignJob } from "./actions/AssignAction.js";

// export const store = configureStore({
//   reducer: {
//     auth: authReducer,
//     job: jobReducer,
//     todayAttendance: todayAttendanceReducer,
//     assignJob:assignjobReducer,
//     assignLocation:assignLocationReducer,
//     assignJobpost:jobAssignmentReducer,
//   },
// });




import { createStore, applyMiddleware, combineReducers } from "redux";
import {thunk} from "redux-thunk";
import authReducer from "./reducers/authReducer";
import jobReducer from "./reducers/jobReducer";
import todayAttendanceReducer from "./reducers/TodayReducer";
import {timeSlotReducer, otAssignReducer, otjobAttendanceReducer, otdetailsReducer} from "./reducers/OTReducer.js"
import {
  assignjobReducer,
  assignLocationReducer,
  jobAssignmentReducer,
} from "./reducers/AssignReducer.js";
import { attendanceReducer } from "./reducers/JobHistoryAllReducer.js";
import { INOUTReducer } from "./reducers/QrReducer.js";
import { OTDetailsReducer } from "./reducers/OTdetailsReducer";
import { sundayDataReducer, holidaysReducer } from "./reducers/OTReducer.js"
import SupervisorWiseOTReducer from "./reducers/SupervisiorWiseReducer.js";
// import JobWiseOTReducer from "./reducers/JobWiseReducer.js";
import NonAllocatedEmpReducer from "./reducers/NonAllocatedEmpReducer.js";
import LocationBasedReducer from "./reducers/LocationBasedReducer.js";
import EmpAllocationReducer from "./reducers/EmpAllocationReducer.js";
import LocationNotOffReducer from "./reducers/LocationNotOffReducer.js";
import OTNonAllocatedLocReducer from "./reducers/OTNonAllocatedLocReducer.js";
import EmpDiscripencyReducer from "./reducers/EmpDiscripencyReducer.js";
import EWODiscripencyReducer from "./reducers/EWODiscripencyReducer.js";
import EmpAllocationCDLJobsReducer from "./reducers/EmpAllocationCDLJobsReducer.js";
import OTEmpNotLeftReducer from "./reducers/OTEmpNotLeftReducer.js";
import { QrJobReducer } from "./reducers/QrJobReducer.js";
import {AccumulateReducer} from "./reducers/ProductionReducer.js";
import AttendanceAdminReducer from "./reducers/AttendanceAdminReducer.js";
import AbsentEmployeeReducer from "./reducers/AbsentEmployeeReducer.js";
import { EmployeeReducer }  from "./reducers/EmpDeatilsReducer.js";
import DesignationBasedReducer from "./reducers/DesignationBasedReducer.js";
import { IWORequestReducer } from "./reducers/IWORequestReducer.js";
import eventsReducer from "./reducers/EventsReducer.js";
import IwoStatusReducer from "./reducers/IwoStatusReducer.js";
import { LeavePriorReducer } from "./reducers/LeavePriorReducer.js";
import { ProductionMonitorReducer } from "./reducers/ProductionMonitorReducer.js";
import { ErectionMonitorReducer } from "./reducers/ErectionMonitorReducer.js";


// Combine all reducers into one root reducer
const rootReducer = combineReducers({
  auth: authReducer,
  job: jobReducer,
  todayAttendance: todayAttendanceReducer,
  otjobAttendance: otjobAttendanceReducer,
  otdetails:otdetailsReducer,
  assignJob: assignjobReducer,
  assignLocation: assignLocationReducer,
  assignJobpost: jobAssignmentReducer,
  timeSlots: timeSlotReducer,
  assignOTpost:otAssignReducer,
  attendance: attendanceReducer,
  otdetails: OTDetailsReducer, //ot1details:otdReducer,
  sundayData: sundayDataReducer,
  holidays:holidaysReducer,
  qr:INOUTReducer,
  supervisorWiseOT: SupervisorWiseOTReducer,
  // jobWiseOT: JobWiseOTReducer,
  nonAllocatedEmp: NonAllocatedEmpReducer,
  locationBased: LocationBasedReducer,
  empAllocation: EmpAllocationReducer,
  locationNotOff: LocationNotOffReducer,
  otNonAllocatedLoc: OTNonAllocatedLocReducer,
  empDiscripency: EmpDiscripencyReducer,
  ewoDiscripency: EWODiscripencyReducer,
  empAllocationCDLJobs: EmpAllocationCDLJobsReducer,
  otEmpNotLeft: OTEmpNotLeftReducer,
  qrJob: QrJobReducer,
  productionAccumulate: AccumulateReducer,
  attendanceAdmin: AttendanceAdminReducer,
  absentEmployee: AbsentEmployeeReducer,
  employee: EmployeeReducer,
  designationBased: DesignationBasedReducer,
  iwoRequest: IWORequestReducer,
  events: eventsReducer,
  iwoStatus: IwoStatusReducer,
  leavePrior: LeavePriorReducer,
  productionMonitor: ProductionMonitorReducer,
  erectionMonitor: ErectionMonitorReducer,
});

// Create the Redux store with rootReducer and middleware
const store = createStore(rootReducer, applyMiddleware(thunk));

export default store; // Ensure this is the default export
